// src/hooks/Companies.jsx
import { useState, useEffect } from 'react';
import { companiesService } from '../api/companies';

export const companiesApi = () => {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Cargar empresas al montar el hook
    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchCompanies = async (filters = {}) => {
        try {
            setLoading(true);
            setError(null);
            const companiesData = await companiesService.getCompanies(filters);
            setCompanies(companiesData);
        } catch (err) {
            console.error('Error fetching companies:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Crear empresa
    const createCompany = async (companyData) => {
        try {
            const newCompany = await companiesService.createCompany(companyData);
            setCompanies(prev => [...prev, newCompany]);
            return newCompany;
        } catch (err) {
            console.error('Error creating company:', err);
            throw err;
        }
    };

    // Actualizar empresa
    const updateCompany = async (nit, companyData) => {
        try {
            const updatedCompany = await companiesService.updateCompany(nit, companyData);
            setCompanies(prev => prev.map(company => 
                company.nit === nit ? updatedCompany : company
            ));
            return updatedCompany;
        } catch (err) {
            console.error('Error updating company:', err);
            throw err;
        }
    };

    // Eliminar empresa
    const deleteCompany = async (nit) => {
        try {
            await companiesService.deleteCompany(nit);
            setCompanies(prev => prev.filter(company => company.nit !== nit));
        } catch (err) {
            console.error('Error deleting company:', err);
            throw err;
        }
    };

    return {
        companies,
        loading,
        error,
        fetchCompanies,
        createCompany,
        updateCompany,
        deleteCompany,
    };
};